(function () {
    'use strict';
    $(document).ready(function () {

        if ($('.homepage').length) {
            var imageSwiper = new Swiper('.swiper-container.image-swiper', {
                // effect: 'fade',
                speed: 600,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true
                },
                pagination: {
                    el: $('.swiper-pagination'),
                    clickable: true
                },
            });
            var textSwiper = new Swiper('.swiper-container.text-swiper', {
                effect: 'fade',
                loop: true,
            });

            imageSwiper.controller.control = textSwiper;
            textSwiper.controller.control = imageSwiper;
        }


        // SWIPERS
        var newsSwiper = new Swiper('.swiper-container.news-swiper', {
            slidesPerView: 3,
            spaceBetween: 25,
            navigation: {
                nextEl: '.next-events',
                prevEl: '.prev-events',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 2
                },
                767: {
                    slidesPerView: 'auto'
                }
            }
        });

        var eventsSwiper = new Swiper('.swiper-container.events-swiper', {
            slidesPerView: 3,
            spaceBetween: 25,
            navigation: {
                nextEl: '.next-events',
                prevEl: '.prev-events',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 2
                },
                767: {
                    slidesPerView: 'auto'
                }
            }
        });

        var publicationsSwiper = new Swiper('.swiper-container.publications-swiper', {
            slidesPerView: 4,
            spaceBetween: 25,
            navigation: {
                nextEl: '.next-publications',
                prevEl: '.prev-publications',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 2
                },
                767: {
                    slidesPerView: 'auto'
                }
            }
        });
    });
}(jQuery));
